
import { Component, Vue, Watch, Prop, Ref, Emit } from "vue-property-decorator";
import { namespace, Getter, Action } from "vuex-class";

const GuardChat = namespace("guardChat");
const Mobile = namespace("mobile");

@Component({
	components: { }
})
export default class ChatButton extends Vue {
    @Mobile.Action loadEventIdsForUser: () => Promise<void>;
	@Mobile.State(state => state.UserSharedEventIds) userSharedEventIds: number[];

	@GuardChat.Getter("getNumberOfUnread") getNumberOfUnread: (eventId: number) => number;	
    @GuardChat.Mutation setMessagesEventId: (eventId: number) => void;
    @GuardChat.State(state => state.activeMessagesEventId) eventId: number;
    @GuardChat.Action loadMessages: (eventId: number) => Promise<void>;

	private currentChatIteration: number = 0;
	private pollTimeout = null;
    private numberOfUnread: number = 0;

	private async mounted(){
		await this.loadEventIdsForUser();
		this.pollForUserSharedEventIds();
	}

	private pollForUserSharedEventIds(){
		this.pollTimeout = setInterval(async () => {
            // Get the events this user is shared on
			await this.loadEventIdsForUser();

            if (this.userSharedEventIds.length > 0) {
                if (this.eventId === 0) {
                    this.setMessagesEventId(this.userSharedEventIds[0]);
                }
            }

            if (this.eventId > 0) {
                // Load the messages for the event (for showing how many unread, and for pre-loading the messages)
                await this.loadMessages(this.eventId);
                this.numberOfUnread = this.getNumberOfUnread(this.eventId);
            }
		}, 10000) as any;
	}

	private beforeDestroy() {
		this.stopPollingForUserEventIds();
	}

	private stopPollingForUserEventIds(){
		if (this.pollTimeout) {
			clearTimeout(this.pollTimeout);
		}
	}

    @Emit("chat-expand-toggle")
	public chatExpandToggle() {
		return true;
	}
}
